var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showContact || _vm.$themeSettings.components.FacebookWidgetPage.enable)?_c('div',{class:_vm.columnClass},[(_vm.showContact)?_c('FooterContact'):_vm._e(),(_vm.$themeSettings.components.FacebookWidgetPage.enable)?_c('FacebookWidgetPage'):_vm._e()],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }